import { useFormContext } from 'react-hook-form';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { DATE_OF_BIRTH_MASK_OPTIONS, DATE_OF_BIRTH_PLACEHOLDER } from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const DateOfBirthInput = (props: Props) => {
  const { name, label, containerClassName, required } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      key="dateOfBirth"
      name={name}
      control={control}
      label={label}
      placeholder={DATE_OF_BIRTH_PLACEHOLDER}
      clearErrors={clearErrors}
      containerClassName={containerClassName}
      required={required}
      maskOptions={DATE_OF_BIRTH_MASK_OPTIONS}
      inputMode="numeric"
      spellCheck={false}
    />
  );
};

export default DateOfBirthInput;
